import { createReducer } from '@reduxjs/toolkit';
import {
  setText,
  setFont,
  setColor,
  appendInvalidText,
  resetInvalidText,
  setIsNoLongerInitialTextEdit,
} from './action';
import type { PersonalizationState } from './state';
import initialPersonalizationState from './state';
import { cleared } from '../General/action';

export const personalizationReducer = createReducer<PersonalizationState>(
  initialPersonalizationState,
  (builder) => {
    builder.addCase(setText, (state, { payload }) => ({
      ...state,
      text: payload,
    }));

    builder.addCase(cleared, () => ({
      ...initialPersonalizationState,
    }));

    builder.addCase(setFont, (state, { payload }) => ({
      ...state,
      font: payload,
    }));

    builder.addCase(setColor, (state, { payload }) => ({
      ...state,
      color: payload,
    }));

    builder.addCase(appendInvalidText, (state, { payload }) => ({
      ...state,
      invalidText: state.invalidText.concat(payload),
    }));

    builder.addCase(resetInvalidText, (state) => ({
      ...state,
      invalidText: '',
    }));

    builder.addCase(setIsNoLongerInitialTextEdit, (state) => ({
      ...state,
      isInitialTextEdit: false,
    }));
  },
);
